import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

/** Lighthouse Member ID + profile open-in-new-tab affordance (proto profile-link). */
export function MemberIdCell({ userId, copyValue = null }) {
  const id = String(userId);
  const profileHref = `/admin/users/${id}`;
  return (
    <span
      className="onyx-member-id"
      data-testid="onyx-member-id"
      data-copy-value={copyValue != null ? String(copyValue) : id}
    >
      <span className="onyx-member-id-value">{id}</span>
      <RouterLink
        to={profileHref}
        target="_blank"
        rel="noopener noreferrer"
        className="onyx-profile-link"
        aria-label={`Open profile for member ${id} in new tab`}
        onClick={(e) => e.stopPropagation()}
      >
        <svg className="onyx-profile-link-icon" width="13" height="13" viewBox="0 0 12 12" aria-hidden="true">
          <path
            d="M4 8 L9.5 2.5 M6.25 2.5 H9.5 V5.75"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.35"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </RouterLink>
    </span>
  );
}

MemberIdCell.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  copyValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
